<p>base-auth-form works!</p>
